import React from "react";
import PuiTypography from "../../../../components/elements/PuiTypography";
import styles from "./VideoPresenter.module.css";

interface VideoPresenterProps {
    content: any;
    presenter: string;
}

export default function VideoPresenter({ content, presenter }: VideoPresenterProps) {
    return (
        <div className={styles.presenter}>
            <div className={styles.presenterImg}>
                <img
                    src={content.professionalImageUrl}
                    className={styles.presenterIcon}
                    alt={content.id}
                    onError={(e) =>
                        (e.currentTarget.src = require("../../../../../src/assets/image/noPresenterImage.svg"))
                    }
                />
            </div>

            <PuiTypography color="secondary-font">{presenter}</PuiTypography>
        </div>
    );
}
